import { EntityAudit } from "@modernary/mui/components/audit";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  distributors: "Distributor.Distributors",
  list: "Distributor.DistributorList",
  new: "Distributor.DistributorNew",
  base: "Distributor.DistributorBase",
  view: "Distributor.DistributorView",
  edit: "Distributor.DistributorEdit",
  users: "Distributor.DistributorUsers",
  userNew: "Distributor.DistributorUserNew",
  distributorReports: "Distributor.DistributorDistributorReports",
  distributorProducts: "Distributor.DistributorDistributorProducts",
  distributorProductEdit: "Distributor.DistributorProductEdit",
  distributorProductNew: "Distributor.DistributorProductNew",
  audit: "Distributor.DistributorAudit",
};

export { names as distributorRouteNames };

const distributorRoutes: RouterOptions["routes"] = [
  {
    path: "/distributor",
    name: names.distributors,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Distributors" },
        component: () => import("@/views/distributor/DistributorList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/distributor/DistributorBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Distributor New", isNew: true },
            component: () => import("@/views/distributor/DistributorEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/distributor/DistributorBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Distributor View" },
            component: () => import("@/views/distributor/DistributorView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Distributor Edit", isForm: true },
            component: () => import("@/views/distributor/DistributorEdit.vue"),
          },
          {
            path: "users",
            name: names.users,
            meta: { title: "Distributor Users" },
            component: () => import("@/views/distributor/DistributorUsers.vue"),
          },
          {
            path: "users/new",
            name: names.userNew,
            meta: { title: "Add Distributor User", isForm: true },
            component: () => import("@/views/distributor/DistributorUser.vue"),
          },
          {
            path: "distributorReports",
            name: names.distributorReports,
            meta: { title: "Distributor Reports" },
            component: () => import("@/views/distributor/DistributorReportChildList.vue"),
          },
          {
            path: "products/list",
            name: names.distributorProducts,
            meta: { title: "Distributor Products" },
            component: () => import("@/views/distributor/DistributorProductChildList.vue"),
          },
          {
            path: "products/:distributorProductId(\\d+)",
            name: names.distributorProductEdit,
            meta: { title: "Distributor Product Edit", isForm: true },
            component: () => import("@/views/distributor/DistributorProduct.vue"),
          },
          {
            path: "product/new",
            name: names.distributorProductNew,
            meta: { title: "Distributor Product New", isForm: true },
            component: () => import("@/views/distributor/DistributorProduct.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Distributor Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Distributor" />,
            },
          },
        ],
      },
    ],
  },
];
export default distributorRoutes;
